import React, { useState, useEffect, useRef } from "react";
import { Typography, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SaveIcon from "@material-ui/icons/Save";
import CloseIcon from "@material-ui/icons/Close";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Moment from "moment";
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";

const CreateLead = (props) => {
  const classes = useStyles();
  const [LeadNo, setLeadNo] = useState("");
  const [Salutation, setSalutation] = useState("");
  const [LeadStatus, setLeadStatus] = useState("New");
  const [Designation, setDesignation] = useState("");
  const [Department, setDepartment] = useState("");
  const [LeadDate, setLeadDate] = useState(new Date());
  const [ContactName, setContactName] = useState("");
  const [Email, setEmail] = useState("");
  const [CompanyName, setCompanyName] = useState("");
  const [Phone, setPhone] = useState("");
  const [IndustryID, setIndustryID] = useState();
  const [Mobile, setMobile] = useState("");
  // const [NoOfEmp, setNoOfEmp] = useState("");
  const [Rating, setRating] = useState("");
  const [LeadSourceID, setLeadSourceID] = useState();
  const [Address1, setAddress1] = useState("");
  const [Address2, setAddress2] = useState("");
  const [City, setCity] = useState("");
  const [CurrencyID, setCurrencyID] = useState("5c4e647e-6dee-4c46-be09-b169bb1e46be");
  const [CountryID, setCountryID] = useState("");
  const [StateID, setStateID] = useState("");
  const [PinCode, setPinCode] = useState("");
  const [GSTNo, setGSTNo] = useState("");
  const [Industrycmb, setIndustrycmb] = useState([]);
  const [Statecmb, setStatecmb] = useState([]);
  const [Currencycmb, setCurrencycmb] = useState([]);
  const [LeadSourcecmb, setLeadSourcecmb] = useState([]);
  const [Countrycmb, setCountrycmb] = useState([]);
  const [response, fetchData] = UseFetchData();
  const [isChecked, setIsChecked] = useState(false);
  const [responseGetData, fetchDataGetData] = UseFetchData();
  const [ComboDataResponse, fetchComboData] = UseFetchData();
  const { value, onChange, ...rest } = props;
  const [cursor, setCursor] = useState(null);
  const ref = useRef(null);

  const validationSchema = Yup.object({
    Salutation: Yup.string().required("Required!"),
    LeadStatus: Yup.string().required("Required!"),
    ContactName: Yup.string().required("Required!"),
    Designation: Yup.string().required("Required!"),
    Department: Yup.string().required("Required!"),
    // NoOfEmp: Yup.number().required("Required!"),
    CompanyName: Yup.string().required("Required!"),
    IndustryID: Yup.string().required("Required!"),
    LeadSourceID: Yup.string().required("Required!"),
    Rating: Yup.string().required("Required!"),
    Mobile: Yup.string().required("Required!"),
    Phone: Yup.string().required("Required!"),
    Email: Yup.string().required("Required!"),
    City: Yup.string().required("Required!"),
    CountryID: Yup.string().required("Required!"),
    StateID: Yup.string().required("Required!"),
    // CurrencyID: Yup.string().required("Required!")
  });



  useEffect(() => {
    const input = ref.current;
    if (input) input.setSelectionRange(cursor, cursor);
  }, [ref, cursor, value]);

  const handleChange = (e) => {
    // setCursor(e.target.selectionStart);
    onChange && onChange(e);
  };

  const onSubmit = (values) => {
    var UpdatedByID = sessionStorage.UID;
    var bodyFormData = new FormData();
    bodyFormData.append("LeadID", props.LeadID);
    bodyFormData.append("LeadStatus", values.LeadStatus);
    bodyFormData.append("LeadDate", LeadDate);
    bodyFormData.append("Salutation", values.Salutation);
    bodyFormData.append("LeadNo", LeadNo);
    bodyFormData.append("ContactName", values.ContactName);
    bodyFormData.append("Designation", values.Designation);
    bodyFormData.append("Department", values.Department);
    bodyFormData.append("CompanyName", values.CompanyName);
    bodyFormData.append("IndustryID", values.IndustryID);
    bodyFormData.append("CurrencyID", values.CurrencyID);
    bodyFormData.append("LeadSourceID", values.LeadSourceID);
    bodyFormData.append("Rating", values.Rating);
    bodyFormData.append("Mobile", values.Mobile);
    bodyFormData.append("Phone", values.Phone);
    bodyFormData.append("Email", values.Email);
    bodyFormData.append("Address1", values.Address1);
    bodyFormData.append("Address2", values.Address2);
    bodyFormData.append("City", values.City);
    bodyFormData.append("CountryID", values.CountryID);
    bodyFormData.append("StateID", values.StateID);
    bodyFormData.append("PINCode", values.PinCode);
    bodyFormData.append("GSTNo", values.GSTNo);
    bodyFormData.append("UpdatedByID", UpdatedByID);
    fetchData("Lead/Save", bodyFormData);
  };

  useEffect(() => {
    // debugger;
    if (isChecked) {
      setAddress1(Address1);
      setAddress2(Address2);
    }
  });

  const GetComboData = () => {
    fetchComboData("Lead/ComboData");
  };

  const SalutationOptions = [
    { key: "Mr.", value: "Mr." },
    { key: "Ms.", value: "Ms." },
    { key: "Mrs.", value: "Mrs." },
    { key: "Dr.", value: "Dr." },
    { key: "Prof.", value: "Prof." },
  ];

  const SalutationData = () => {
    let SalutationCombo = SalutationOptions.map((data) => (
      <option key={data.key} value={data.value}>
        {data.key}
      </option>
    ));
    return SalutationCombo;
  };

  const RatingOptions = [
    { key: "Hot", value: "Hot" },
    { key: "Warm", value: "Warm" },
    { key: "Cold", value: "Cold" },
  ];

  const RatingData = () => {
    let RatingCombo = RatingOptions.map((data) => (
      <option key={data.key} value={data.value}>
        {data.key}
      </option>
    ));
    return RatingCombo;
  };

  const LeadStatusOptions = [
    { key: "Unqualified", value: "Unqualified" },
    { key: "New", value: "New" },
    { key: "Working", value: "Working" },
    { key: "Nurturing", value: "Nurturing" },
    { key: "Qualified", value: "Qualified" },
    { key: "Opportunities", value: "Opportunities" },
  ];

  const LeadStatusData = () => {
    let LeadStatusCombo = LeadStatusOptions.map((data) => (
      <option key={data.key} value={data.value}>
        {data.key}
      </option>
    ));
    return LeadStatusCombo;
  };

  const IndustryData = (options) => {
    if (options !== undefined) {
      let Industry = options.map((data) => (
        <option key={data.Industry} value={data.IndustryID}>
          {data.Industry}
        </option>
      ));
      setIndustrycmb(Industry);
    }
  };

  const StateData = (options) => {
    if (options !== undefined) {
      let State = options.map((data) => (
        <option key={data.StateName} value={data.StateID}>
          {data.StateName}
        </option>
      ));
      setStatecmb(State);
    }
  };

  const CountryData = (options) => {
    if (options !== undefined) {
      let Country = options.map((data) => (
        <option key={data.Country} value={data.CountryID}>
          {data.Country}
        </option>
      ));
      setCountrycmb(Country);
    }
  };

  const CurrencyData = (options) => {
    if (options !== undefined) {
      let Currency = options.map((data) =>
        <option
          key={data.Currency}
          value={data.CurrencyID}
        >
          {data.Currency}
        </option>
      );
      setCurrencycmb(Currency)
    }
  }

  const LeadSourceData = (options) => {
    if (options !== undefined) {
      let LeadSource = options.map((data) => (
        <option key={data.LeadSource} value={data.LeadSourceID}>
          {data.LeadSource}
        </option>
      ));
      setLeadSourcecmb(LeadSource);
    }
  };

  const GetByIDData = () => {
    debugger;
    var bodyFormData = new FormData();
    bodyFormData.append("LeadID", props.LeadID);
    fetchDataGetData("Lead/GetByID", bodyFormData);
  };

  const onCheckChange = (e) => {
    // debugger;
    setIsChecked(e.target.checked);
    console.log(isChecked);
  };

  useEffect(() => {
    if (responseGetData !== undefined && responseGetData.length > 0) {
      setSalutation(responseGetData[0].Salutation);
      setLeadNo(responseGetData[0].LeadNo);
      setLeadStatus(responseGetData[0].LeadStatus);
      setContactName(responseGetData[0].ContactName);
      setLeadSourceID(responseGetData[0].LeadSourceID === null ? "" : responseGetData[0].LeadSourceID);
      setLeadDate(responseGetData[0].LeadDate);
      setDepartment(responseGetData[0].Department);
      setDesignation(responseGetData[0].Designation);
      setCompanyName(responseGetData[0].CompanyName);
      setCurrencyID(responseGetData[0].CurrencyID === null ? "" : responseGetData[0].CurrencyID);
      setIndustryID(responseGetData[0].IndustryID === null ? "" : responseGetData[0].IndustryID);
      setRating(responseGetData[0].Rating);
      setPhone(responseGetData[0].Phone);
      setMobile(responseGetData[0].Mobile);
      setAddress1(responseGetData[0].Address1);
      setAddress2(responseGetData[0].Address2);
      setCountryID(responseGetData[0].CountryID === null ? "" : responseGetData[0].CountryID);
      setCity(responseGetData[0].City);
      setStateID(responseGetData[0].StateID === null ? "" : responseGetData[0].StateID);
      setPinCode(responseGetData[0].PINCode);
      setGSTNo(responseGetData[0].GSTNo);
      setEmail(responseGetData[0].Email);
    }
  }, [responseGetData]);


  useEffect(() => {
    debugger;
    if (response.Response === true) {
      alert("Data Saved Succesfully.");
      props.PopulateData();
      props.setOpen(false);
    }
    else if (response.Response === false) {
      if (response.Message.includes("Already") === true) {
        alert(response.Message);
      } else {
        alert("Failed.");
      }
    }
  }, [response]);

  useEffect(() => {
    if (ComboDataResponse !== undefined) {
      if (
        ComboDataResponse["Industry"] !== undefined &&
        ComboDataResponse["State"] !== undefined &&
        ComboDataResponse["Country"] !== undefined &&
        ComboDataResponse["LeadSource"] !== undefined &&
        ComboDataResponse["Currency"] !== undefined
      ) {
        IndustryData(ComboDataResponse["Industry"]);
        StateData(ComboDataResponse["State"]);
        CountryData(ComboDataResponse["Country"]);
        LeadSourceData(ComboDataResponse["LeadSource"]);
        CurrencyData(ComboDataResponse["Currency"]);
      }
    }
  }, [ComboDataResponse]);

  useEffect(() => {
    GetComboData();
    if (props.LeadID !== "" && props.Mode === "Update") {
      GetByIDData();
    }
  }, []);

  let SalutationCombo = SalutationData();
  let RatingCombo = RatingData();
  let LeadStatusCombo = LeadStatusData();

  return (
    <div>
      <Formik
        initialValues={{
          LeadStatus: LeadStatus, LeadNo: LeadNo, Salutation: Salutation, ContactName: ContactName,
          Designation: Designation, Department: Department, CurrencyID: CurrencyID, Email: Email, CompanyName: CompanyName, Phone: Phone,
          IndustryID: IndustryID, Mobile: Mobile, Rating: Rating, LeadSourceID: LeadSourceID,
          Address1: Address1, Address2: Address2, City: City, CountryID: CountryID, StateID: StateID, PinCode: PinCode, GSTNo: GSTNo,
        }}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {(formik) => {
          return (
            <Form>
              <Typography
                className={classes.headertext}
                style={{ marginTop: "-16px" }}
                noWrap
              >
                Lead Information
              </Typography>
              <Grid spacing={2} container direction="row">
                <Grid item xs={2}>
                  <label
                    htmlFor={"LeadStatus"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Lead Status"}
                  </label>
                </Grid>
                <Grid item xs={2}>
                  <BiztranControlsFormik
                    control="select"
                    // label='Lead Status'
                    name="LeadStatus"
                    options={LeadStatusCombo}
                    onChange={(e) => setLeadStatus(e.target.value)}
                  />
                </Grid>
                <Grid item xs={2}>
                  <label
                    htmlFor={"LeadNo"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Lead No"}
                  </label>
                </Grid>
                <Grid item xs={2}>
                  <BiztranControlsFormik
                    control="input"
                    type="text"
                    // label='Lead No'
                    name="LeadNo"
                    disabled={true}
                    onChange={(e) => setLeadNo(e.target.value)}
                  />
                </Grid>
                <Grid item xs={2}>
                  <label
                    htmlFor={"Salutation"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Salutation"}
                  </label>
                </Grid>
                <Grid item xs={2}>
                  <BiztranControlsFormik
                    control="select"
                    // label='Account Type'
                    name="Salutation"
                    options={SalutationCombo}
                    onChange={(e) => setSalutation(e.target.value)}
                  />
                </Grid>
                <Grid item xs={2}>
                  <label
                    htmlFor={"ContactName"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Contact Name"}
                  </label>
                </Grid>
                <Grid item xs={2}>
                  <BiztranControlsFormik
                    // autoFocus="autofocus"
                    control="input"
                    type="text"
                    // label='Contact Name'
                    name="ContactName"
                    ref={ref}
                    value={ContactName}
                    onChange={(e) => {
                      setContactName(e.target.value)
                      handleChange()
                    }
                    }
                  />
                </Grid>
                <Grid item xs={2}>
                  <label
                    htmlFor={"Email"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Email"}
                  </label>
                </Grid>
                <Grid item xs={2}>
                  <BiztranControlsFormik
                    // autoFocus="autofocus"
                    control="input"
                    type="text"
                    // label='Email'
                    name="Email"
                    ref={ref}
                    value={Email}
                    onChange={(e) => {
                      setEmail(e.target.value)
                      handleChange()
                    }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <label
                    htmlFor={"CompanyName"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Company Name"}
                  </label>
                </Grid>
                <Grid item xs={2}>
                  <BiztranControlsFormik
                    // autoFocus="autofocus"
                    control="input"
                    type="text"
                    // label='Company Name'
                    name="CompanyName"
                    ref={ref}
                    value={CompanyName}
                    onChange={(e) => {
                      setCompanyName(e.target.value)
                      handleChange()
                    }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <label
                    htmlFor={"Designation"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Designation"}
                  </label>
                </Grid>
                <Grid item xs={2}>
                  <BiztranControlsFormik
                    // autoFocus="autofocus"
                    control="input"
                    type="text"
                    // label='Account Type'
                    name="Designation"
                    ref={ref}
                    value={Designation}
                    onChange={(e) => {
                      setDesignation(e.target.value)
                      handleChange()
                    }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <label
                    htmlFor={"Department"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Department"}
                  </label>
                </Grid>
                <Grid item xs={2}>
                  <BiztranControlsFormik
                    // autoFocus="autofocus"
                    control="input"
                    type="text"
                    // label='Contact Name'
                    name="Department"
                    ref={ref}
                    value={Department}
                    onChange={(e) => {
                      setDepartment(e.target.value)
                      handleChange()
                    }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <label htmlFor={"Phone"}
                    style={{
                      display: 'block', width: '100%'
                    }}>
                    {"Phone"}
                  </label>
                </Grid>
                <Grid item xs={2}>
                  <BiztranControlsFormik
                    // autoFocus="autofocus"
                    control='input'
                    type='text'
                    // label='Phone No'
                    name='Phone'
                    ref={ref}
                    value={Phone}
                    onChange={(e) => {
                      setPhone(e.target.value)
                      handleChange()
                    }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <label
                    htmlFor={"IndustryID"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Industry"}
                  </label>
                </Grid>
                <Grid item xs={2}>
                  <BiztranControlsFormik
                    control="select"
                    // label='Industry'
                    name="IndustryID"
                    options={Industrycmb}
                    onChange={(e) => setIndustryID(e.target.value)}
                  />
                </Grid>
                <Grid item xs={2}>
                  <label
                    htmlFor={"Mobile"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Mobile"}
                  </label>
                </Grid>
                <Grid item xs={2}>
                  <BiztranControlsFormik
                    // autoFocus="autofocus"
                    control="input"
                    type="text"
                    // label='Mobile'
                    name="Mobile"
                    ref={ref}
                    value={Mobile}
                    onChange={(e) => {
                      setMobile(e.target.value)
                      handleChange()
                    }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <label
                    htmlFor={"CurrencyID"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Currency"}
                  </label>
                </Grid>
                <Grid item xs={2}>
                  <BiztranControlsFormik
                    control='select'
                    // label='No Of Employees'
                    name="CurrencyID"
                    options={Currencycmb}
                    onChange={(e) => setCurrencyID(e.target.value)}
                  />
                </Grid>
                <Grid item xs={2}>
                  <label
                    htmlFor={"GSTIN"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"GSTIN"}
                  </label>
                </Grid>
                <Grid item xs={2}>
                  <BiztranControlsFormik
                    control="input"
                    type="text"
                    // label='GST No'
                    name="GSTNo"
                    ref={ref}
                    value={GSTNo}
                    onChange={(e) => {
                      setGSTNo(e.target.value)
                      handleChange()
                    }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <label
                    htmlFor={"Rating"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Rating"}
                  </label>
                </Grid>
                <Grid item xs={2}>
                  <BiztranControlsFormik
                    control="select"
                    // label='Rating'
                    name="Rating"
                    options={RatingCombo}
                    onChange={(e) => setRating(e.target.value)}
                  />
                </Grid>
                <Grid item xs={2}>
                  <label
                    htmlFor={"LeadSourceID"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Lead Source"}
                  </label>
                </Grid>
                <Grid item xs={2}>
                  <BiztranControlsFormik
                    control="select"
                    // label='Lead Source'
                    name="LeadSourceID"
                    options={LeadSourcecmb}
                    onChange={(e) => setLeadSourceID(e.target.value)}
                  />
                </Grid>
              </Grid>
              <Grid spacing={2} container direction="row">
                <Grid item xs={12}>
                  <Typography className={classes.headertext} noWrap>
                    Address Information
                  </Typography>
                </Grid>
                {/* <Grid item xs={12} style={{ display: "flex" }}>
                  <label>Address1 Same as Address2?</label>
                  <div style={{ paddingLeft: 10 }}>
                    <input
                      type="checkbox"
                      name="chkbox"
                      checked={isChecked}
                      onChange={onCheckChange}
                    ></input>
                  </div>
                </Grid> */}
                <Grid item xs={2}>
                  <label
                    htmlFor={"Address1"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Address1"}
                  </label>
                </Grid>
                <Grid item xs={4}>
                  <BiztranControlsFormik
                    // autoFocus="autofocus"
                    control="textarea"
                    type="text"
                    // label='Address'
                    name="Address1"
                    ref={ref}
                    value={Address1}
                    onChange={(e) => {
                      setAddress1(e.target.value)
                      handleChange()
                    }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <label
                    htmlFor={"Address2"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Address2"}
                  </label>
                </Grid>
                <Grid item xs={4}>
                  <BiztranControlsFormik
                    // autoFocus="autofocus"
                    control="textarea"
                    type="text"
                    // label='Address'
                    name="Address2"
                    ref={ref}
                    value={Address2}
                    onChange={(e) => {
                      setAddress2(e.target.value)
                    }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <label
                    htmlFor={"City"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"City"}
                  </label>
                </Grid>
                <Grid item xs={4}>
                  <BiztranControlsFormik
                    // autoFocus="autofocus"
                    control="input"
                    type="text"
                    // label='City'
                    name="City"
                    ref={ref}
                    value={City}
                    onChange={(e) => {
                      setCity(e.target.value)
                      handleChange()
                    }
                    }
                  />
                </Grid>
                <Grid item xs={2}>
                  <label
                    htmlFor={"CountryID"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Country"}
                  </label>
                </Grid>
                <Grid item xs={4}>
                  <BiztranControlsFormik
                    control="select"
                    // label='Country'
                    options={Countrycmb}
                    name="CountryID"
                    onChange={(e) => setCountryID(e.target.value)}
                  />
                </Grid>
                <Grid item xs={2}>
                  <label
                    htmlFor={"StateID"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"State"}
                  </label>
                </Grid>
                <Grid item xs={4}>
                  <BiztranControlsFormik
                    control="select"
                    // label='State'
                    name="StateID"
                    options={Statecmb}
                    onChange={(e) => setStateID(e.target.value)}
                  />
                </Grid>
                <Grid item xs={2}>
                  <label
                    htmlFor={"PinCode"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"PIN Code"}
                  </label>
                </Grid>
                <Grid item xs={4}>
                  <BiztranControlsFormik
                    // autoFocus="autofocus"
                    control="input"
                    type="text"
                    // label='PIN Code'
                    name="PinCode"
                    ref={ref}
                    value={PinCode}
                    onChange={(e) => {
                      setPinCode(e.target.value)
                      handleChange()
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <div style={{ width: "100%" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignContent: "center",
                      }}
                    >
                      <BiztranControls.Button
                        text="SAVE"
                        type="submit"
                        startIcon={<SaveIcon />}
                      />
                      <BiztranControls.Button
                        text="CLOSE"
                        startIcon={<CloseIcon />}
                        onClick={() => {
                          props.setOpen(false);
                        }}
                      />
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  headertext: {
    background: "#e6d8d8", //theme.palette.tertiary.gradient,
    color: "#3d3d3d",
    height: "2rem",
    paddingLeft: "30px",
    fontSize: "1.5rem",
    //marginTop: "-16px",
    marginBottom: "10px",
    marginLeft: "-24px",
    marginRight: "-24px",
    //   borderRadius: "1rem",
  },
}));

export default CreateLead;
